import { useGetUserProfileByAddress } from '@/api/query'
import { GradientText } from '@/components/atoms/GradientText/GradientText'
import { AppModals, useAppModal } from '@/context/ModalProvider'
import { Flex, Text, Box } from '@chakra-ui/react'
import { Avatar } from '@/components/atoms/Avatar'
import { StatsRow } from '@/components/atoms/StatsRow/StatsRow'
import { FiatOrCryptoAmount } from '@/components/atoms/Amount/Amount'
import { CopiableLink } from '@/components/atoms/CopiableLink/CopiableLink'
import { SHU_DENOM } from '@/constants/constants'
import { TokenMoney } from '@ninjablaze/sdk-ts'
import { useTranslation } from 'next-i18next/pages'

export const BetPanel = ({
  address,
  amount,
  badges,
}: {
  address: string
  amount: string
  badges: Array<[string, string, () => void] | [string, string]>
}) => {
  const { data } = useGetUserProfileByAddress(address)
  const modal = useAppModal()
  const numberOfNfts = data?.nfts?.totalCount
  const isNftOwner = Boolean(numberOfNfts)
  const { t } = useTranslation()

  return (
    <Box bg={'ninja.600'} position={'relative'} overflow={'hidden'} rounded={'xl'} p={4}>
      <Flex mb={3} alignItems={'center'} gap={3}>
        <Box
          border={'1px solid'}
          borderColor={'transparent'}
          transition={'.2s'}
          p={0.5}
          _hover={{
            borderColor: 'ninja.400',
          }}
          rounded={'full'}
        >
          <Avatar
            cursor={'pointer'}
            onClick={() => modal.openModalNew(AppModals.UserStats, { address })}
            boxShadow={isNftOwner ? '0px 0px 10px 0px #5D52EE;' : 'none'}
            src={data?.user?.profileAvatar || ''}
            size={'lg'}
          />
        </Box>
        {isNftOwner ? (
          <GradientText
            numberOfNfts={numberOfNfts!}
            props={{
              fontWeight: 700,
            }}
          >
            {data?.user?.profileUserName}
          </GradientText>
        ) : (
          <Text fontWeight={700} color={'ninja.100'}>
            {data?.user?.profileUserName}
          </Text>
        )}
      </Flex>
      <StatsRow
        name={t('common.bet')}
        value={<FiatOrCryptoAmount value={new TokenMoney(amount, SHU_DENOM)} iconSize={'18px'} />}
      />
      {badges.map(([title, value, callback], index) => {
        return (
          <Flex
            onClick={() => callback?.()}
            cursor={callback ? 'pointer' : 'auto'}
            border={'1px solid'}
            borderColor={'whiteAlpha.200'}
            key={index}
            py={1.5}
            px={4}
            gap={2}
            rounded={'xl'}
            alignItems={'center'}
            justifyContent={'space-between'}
            _hover={{
              color: callback ? 'ninja.100' : 'brand.white',
            }}
            fontWeight={600}
            as={'span'}
            fontSize={'sm'}
          >
            <Text color={'ninja.200'} fontWeight={500} fontSize={'sm'}>
              {title}
            </Text>
            <CopiableLink maxLength={36} trimmedLength={8} value={value} />
          </Flex>
        )
      })}
    </Box>
  )
}
